import type { SelectedTalent } from '../common/selectedTalent';
import type { Station } from '../common/station';
import type { Department } from '../helpers/department';
import type { MissionProfile } from '../helpers/missionProfiles';
import type {
  StationFrame,
  StationFrameAppearance,
} from '../helpers/stationFrame';
import type { System } from '../helpers/systems';
import type { Weapon } from '../helpers/weapons';

export const CREATE_STATION = 'CREATE_STATION';
export const SET_STATION_MISSION_PROFILE = 'SET_STATION_MISSION_PROFILE';
export const SET_STATION_NAME = 'SET_STATION_NAME';
export const SET_STATION_TRAITS = 'SET_STATION_TRAITS';
export const SET_STATION_CUSTOM_SCALE = 'SET_STATION_CUSTOM_SCALE';
export const MODIFY_STATION_CUSTOM_FRAME_SYSTEM =
  'MODIFY_STATION_CUSTOM_FRAME_SYSTEM';
export const MODIFY_STATION_CUSTOM_FRAME_DEPARTMENT =
  'MODIFY_STATION_CUSTOM_FRAME_DEPARTMENT';
export const ADD_STATION_WEAPON = 'ADD_STATION_WEAPON';
export const DELETE_STATION_WEAPON = 'DELETE_STATION_WEAPON';
export const SET_STATION_MISSION_PROFILE_TALENT =
  'SET_STATION_MISSION_PROFILE_TALENT';
export const SET_STATION_ADDITIONAL_TALENTS = 'SET_STATION_ADDITIONAL_TALENTS';
export const SET_STATION_FRAME = 'SET_STATION_FRAME';
export const SET_STATION_FRAME_APPEARANCE = 'SET_STATION_FRAME_APPEARANCE';

export function createStation(station: Station) {
  const payload = { station: station };
  return {
    type: CREATE_STATION,
    payload: payload,
  };
}

export function setStationMissionProfile(missionProfile: MissionProfile) {
  const payload = { missionProfile: missionProfile };
  return {
    type: SET_STATION_MISSION_PROFILE,
    payload: payload,
  };
}

export function setStationMissionProfileTalent(talent: SelectedTalent) {
  const payload = { talent: talent };
  return {
    type: SET_STATION_MISSION_PROFILE_TALENT,
    payload: payload,
  };
}

export function setStationName(name: string) {
  const payload = { name: name };
  return {
    type: SET_STATION_NAME,
    payload: payload,
  };
}

export function setStationCustomScale(scale: number) {
  const payload = { scale: scale };
  return {
    type: SET_STATION_CUSTOM_SCALE,
    payload: payload,
  };
}

export function setStationTraits(traits: string[]) {
  const payload = { traits: traits };
  return {
    type: SET_STATION_TRAITS,
    payload: payload,
  };
}

export function changeStationCustomFrameSystem(delta: number, system: System) {
  const payload = { delta: delta, system: system };
  return {
    type: MODIFY_STATION_CUSTOM_FRAME_SYSTEM,
    payload: payload,
  };
}

export function changeStationCustomFrameDepartment(
  delta: number,
  department: Department,
) {
  const payload = { delta: delta, department: department };
  return {
    type: MODIFY_STATION_CUSTOM_FRAME_DEPARTMENT,
    payload: payload,
  };
}

export function addStationWeapon(weapon: Weapon) {
  const payload = { weapon: weapon };
  return {
    type: ADD_STATION_WEAPON,
    payload: payload,
  };
}

export function deleteStationWeapon(weapon: Weapon) {
  const payload = { weapon: weapon };
  return {
    type: DELETE_STATION_WEAPON,
    payload: payload,
  };
}

export function setStationAdditionalTalents(talents: SelectedTalent[]) {
  const payload = { talents: talents };
  return {
    type: SET_STATION_ADDITIONAL_TALENTS,
    payload: payload,
  };
}

export function setStationFrame(frame: StationFrame) {
  const payload = { frame: frame };
  return {
    type: SET_STATION_FRAME,
    payload: payload,
  };
}

export function setStationFrameAppearance(appearance: StationFrameAppearance) {
  const payload = { appearance: appearance };
  return {
    type: SET_STATION_FRAME_APPEARANCE,
    payload: payload,
  };
}
